/* eslint-disable @typescript-eslint/no-var-requires */
const color: { default: string } = require("./teamsBot/color.png");
const outline: { default: string } = require("./teamsBot/outline.png");

export {
  color,
  outline
};
